// Types for analytics (PostHog, etc.)

// User properties tracked in PostHog
export interface AnalyticsUserProperties {
  email?: string;
  name?: string;
}

// Event names for tracking
export enum AnalyticsEventName {
  // State changes
  AqiStandardChanged = 'aqi_standard_changed',
  LoginStateChanged = 'login_state_changed',
  LoginMethodChanged = 'login_method_changed',
  MarkerChanged = 'marker_changed',
  MyLocationChanged = 'my_location_changed',
  SelectedSearchedLocationChanged = 'selected_searched_location_changed',
  SearchedLocationByText = 'searched_location_by_text',
  LocationPermissionChanged = 'location_permission_changed',
  ViewportChanged = 'viewport_changed',
  FollowCreated = 'follow_created',
  FollowDeleted = 'follow_deleted',
  UITourIsOpenChanged = 'ui_tour_is_open_changed',
  UITourStepChanged = 'ui_tour_step_changed',
  UITourCompleted = 'ui_tour_completed',
  ExploreFurtherIsOpenChanged = 'explore_further_is_open_changed',

  // UI Gestures
  ClosedDatasourceDetails = 'closed_datasource_details',
  DownloadedMeasurements = 'downloaded_measurements',
  OpenedAqiInfoPanel = 'opened_aqi_info_panel',
  OpenedPollutantInfoPanel = 'opened_pollutant_info_panel',
  SelectedMapMarker = 'datasourceClicked', // legacy naming convention
  ClearedMapMarker = 'datasourceCleared', // legacy naming convention
  SharedDatasourceDetails = 'shared_datasource_details',
  SelectedMeasurementChartOption = 'selected_measurement_chart_option',
  ClickedFollowDatasourceButton = 'clicked_follow_datasource_button',
  UITourLearnMoreClicked = 'ui_tour_learn_more_clicked',
  ExploreFurtherClickedBackToNetwork = 'explore_further_clicked_back_to_network',
  ExploreFurtherClickedViewWorldMap = 'explore_further_clicked_view_world_map',
}

// Event properties for tracking
export interface AnalyticsProperties {
  [key: string]: unknown;
}
